import React from 'react';
import styled from 'styled-components';
import { ReviewStar as _ReviewStar, Typo } from 'tmt-ui-kit';

const Container = styled.div`
  display: flex;
  width: fit-content;
`;

const ReviewStar = styled(_ReviewStar)`
  > span {
    margin-right: 0 !important;
  }
`;

const ReviewCount = styled(Typo.Paragraph)`
  font-size: 12px !important;
  margin: 0 0 0 5px !important;
  line-height: 1.67 !important;
  font-weight: 400 !important;
  color: ${props => props.theme.darkGray2} !important;
`;

const ReviewRating = styled(Typo.Paragraph)`
  font-size: 12px !important;
  margin: 0 5px 0 0 !important;
  line-height: 1.67 !important;
  font-weight: 600 !important;
`;

const Rating = (props) => {
  const { score, count } = props;
  return (
    <Container>
      <ReviewRating>{score}</ReviewRating>
      <ReviewStar hideScoreText score={score} />
      <ReviewCount>({count})</ReviewCount>
    </Container>
  );
};

export default Rating;
